/*!

=========================================================
* Vue Argon Dashboard - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or
* substantial portions of the Software.

*/
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import Tooltip from 'vue-directive-tooltip';
import VueSocketIO from 'vue-socket.io';
import { sync } from 'vuex-router-sync';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import App from './App.vue';
import router from './router';
import store from './store';
import './registerServiceWorker';
import ArgonDashboard from './plugins/argon-dashboard';
import Config from './config';
import Rollbar from 'vue-rollbar';

Vue.config.productionTip = false;

axios.defaults.baseURL = Config.apiBaseURL;
axios.defaults.headers.common.Accept = 'application/json';
axios.defaults.headers.common['Content-Type'] = 'application/json';

console.log(Config.apiBaseURL);

if (process.env.NODE_ENV === 'production') {
  Vue.use(Rollbar, {
    accessToken: '33e78978f22c46bf8de1511db08b8665',
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: true,
    source_map_enabled: true,
    environment: 'production',
    payload: {
      client: {
          javascript: {
              code_version: '1.0'
          }
      }
    }
  })
}

Vue.use(new VueSocketIO({
  debug: true,
  connection: Config.apiBaseURL,
}));

Vue.use(VueAxios, axios);
Vue.use(Tooltip);

sync(store, router); // done. Returns an unsync callback fn

Vue.use(ArgonDashboard);
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
